const routes = {
  login: {
    root: "/login",
  },
  upload: {
    upload: "/upload",
  },
  history: {
    history: "/history",
  },
  homePage: {
    homePage: "/homePage",
  },
  customerOrders: {
    customerOrders: "/customerOrders",
  },
  orderDetails: {
    orderDetails: "/orderDetails",
  },
};

export default routes;
